import { render, staticRenderFns } from "./fifthStep.vue?vue&type=template&id=053d8a3b&scoped=true&slot=groupTitle&"
import script from "./fifthStep.vue?vue&type=script&lang=js&"
export * from "./fifthStep.vue?vue&type=script&lang=js&"
import style0 from "./fifthStep.vue?vue&type=style&index=0&id=053d8a3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d8a3b",
  null
  
)

export default component.exports